import './index.scss'

import Modal, { ModalButtonStyle } from '@components/Modal'

import closeIcon from 'url:@icon/close.svg';
import warningIcon from 'url:@icon/error-icon.svg';

// Styled after the Settings delete modals: disconnecting stops things the
// church may be relying on without noticing, so it reads as a warning.
export default function DisconnectModal(props: {
  isOpen: boolean,
  providerName?: string,
  // What stops working, specific to the provider.
  consequences?: string,
  isDisconnecting: boolean,
  error: string | null,
  close: () => void,
  confirm: () => void
}) {
  const name = props.providerName ?? 'this provider';

  return <Modal
    id='disconnect-integration-modal'
    isOpen={props.isOpen}
    footerButtons={[
      {
        title: props.isDisconnecting ? 'Disconnecting...' : `Disconnect ${name}`,
        style: ModalButtonStyle.FILLED,
        enabled: !props.isDisconnecting,
        onClick: props.confirm
      },
      {
        title: 'Cancel',
        style: ModalButtonStyle.OUTLINE,
        enabled: !props.isDisconnecting,
        onClick: props.close
      }
    ]}>
    <div className='disconnect-integration-modal-content'>
      <div className='header'>
        <button
          type='button'
          className='close'
          disabled={props.isDisconnecting}
          onClick={props.close}>
          <img className='icon' src={closeIcon} alt='Close icon' />
        </button>

        <h3 className='title'>Disconnect {name}</h3>
      </div>

      {props.error ? <p className='save-error'>{props.error}</p> : null}

      <div className='body'>
        <img src={warningIcon} alt='' aria-hidden='true' className='warning-icon' />

        <p className='warning-copy'>
          <strong>Are you sure you want to disconnect {name}?</strong>
        </p>

        {props.consequences ? <p className='warning-copy'>{props.consequences}</p> : null}

        <p className='warning-copy caption'>
          This takes effect immediately for your whole church. To reconnect, an admin will need to set up the
          connection again from this page.
        </p>
      </div>
    </div>
  </Modal>
}
